import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/order/reverse.js
// module id = 991
// module chunks = 0